import { useState } from "react";
import { toast } from "sonner";
import { Ban, CheckCircle2, FileSignature, Hand, RotateCcw, Star } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";

export const OPTION_STATUS = {
  client_pick: { label: "Client's Pick", color: "#C6A55C", Icon: Star },
  booked: { label: "Booked", color: "#059669", Icon: CheckCircle2 },
  not_selected: { label: "Not Selected", color: "#9CA3AF", Icon: null },
  unavailable: { label: "Unavailable", color: "#9CA3AF", Icon: Ban },
};

const PICKABLE = ["new", "options_sent", "booking_requested"];

export const OptionStatusBadge = ({ o }) => {
  const s = OPTION_STATUS[o.status];
  if (!s) return null;
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-[0.62rem] tracking-[0.16em] uppercase text-white font-semibold" style={{ background: s.color }}
      data-testid={`option-${o.rank}-status-badge`}>
      {s.Icon && <s.Icon size={12} />} {s.label}
    </span>
  );
};

export function OptionStatusActions({ o, trip, staff, onChanged }) {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const run = async (fn, done) => {
    setBusy(true);
    try { onChanged((await fn()).data); toast.success(done); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const open = PICKABLE.includes(trip.status);
  const btn = "frame-btn !py-2.5 !px-4";
  return (
    <>
      {open && o.status === "available" && (
        <button className={btn} disabled={busy} onClick={() => run(() => api.post(`/options/${o.id}/pick`), "Marked as the client's pick. Booking requested.")} data-testid={`option-${o.rank}-client-pick-btn`}>
          <Hand size={13} /> Client wants this one
        </button>
      )}
      {open && o.status === "client_pick" && (
        <button className={btn} disabled={busy} onClick={() => run(() => api.delete(`/options/${o.id}/pick`), "Client's pick cleared")} data-testid={`option-${o.rank}-clear-pick-btn`}>
          <RotateCcw size={13} /> Clear pick
        </button>
      )}
      {staff && o.status === "client_pick" && trip.status === "booking_requested" && (
        <button className={`${btn} gold`} disabled={busy} onClick={() => run(() => api.post(`/options/${o.id}/contract-signed`), "Operator contract signed. Trip confirmed.")} data-testid={`option-${o.rank}-contract-signed-btn`}>
          <FileSignature size={13} /> Operator contract signed
        </button>
      )}
      {staff && o.status !== "booked" && (
        <button className={btn} disabled={busy} data-testid={`option-${o.rank}-availability-btn`}
          onClick={() => run(() => api.post(`/options/${o.id}/availability`, { unavailable: o.status !== "unavailable" }), o.status === "unavailable" ? "Option available again" : "Marked unavailable")}>
          <Ban size={13} /> {o.status === "unavailable" ? "Mark available" : "Mark unavailable"}
        </button>
      )}
    </>
  );
}
